export const maxSavedColors = 7;
